import LIVEINTENT_BRAND_MAP from './liveintent-brand-map.json';
import { initLiveIntent } from './liveintent';

/**
 * Prebid bidding library.
 */
function ANBiddingLibraryPrebid(logger){

    ANBiddingLibrary.call(this, logger);
}

ANBiddingLibraryPrebid.prototype             = Object.create(ANBiddingLibrary.prototype);
ANBiddingLibraryPrebid.prototype.constructor = ANBiddingLibrary;

/**
 * @inheritdoc
 */
ANBiddingLibraryPrebid.prototype.setupAuction = function(auction, overrideDimensions){

    auction      = ANBiddingLibrary.prototype.setupAuction.call(this, auction, overrideDimensions);
    var adWidth  = null;
    var adHeight = null;
    var adSize   = null;

    if(overrideDimensions && overrideDimensions.width && overrideDimensions.height){

        adWidth  = overrideDimensions.width;
        adHeight = overrideDimensions.height;
        adSize   = [adWidth, adHeight];
    }

    var ads = auction.getGamAdSlots();

    if(!ads || ads.length === 0){

        this.__logger.debug('Unable to setup Prebid: no ads found!', auction);
        return auction;
    }

    for(var x in ads){

        var ad                    = ads[x];
        var prebidAdUnitTemplates = ad.getPrebidAdUnitTemplates();
        
        if(!prebidAdUnitTemplates || !Array.isArray(prebidAdUnitTemplates) || prebidAdUnitTemplates.length === 0){

            this.__logger.debug('Unable to setup Prebid: no prebidAdUnitTemplates found!', ad);
            continue;
        }

        for(var y in prebidAdUnitTemplates){

            var prebidAdUnitTemplate = prebidAdUnitTemplates[y];

            if(!prebidAdUnitTemplate || typeof prebidAdUnitTemplate !== 'string'){

                this.__logger.warn('A Prebid ad unit template is not valid!', {
                    adElementId: ad.adElementId,
                    prebidAdUnitTemplate
                });
                continue;
            }

            // Replace macros in template to construct a concrete Prebid ad unit.
            prebidAdUnitTemplate = prebidAdUnitTemplate.replaceAll('DIR_AD_ELEMENT_ID', ad.adElementId);
            var prebidAdUnit     = JSON.parse(prebidAdUnitTemplate);

            // Transaction Id.
            var tid = ('TheGamer' === window.adsNinjaHeaderBiddingManager.getBrandName()) ? ad.getAuctionId() : ad.getTid();

            if(tid && prebidAdUnit.hasOwnProperty('ortb2Imp') && prebidAdUnit.ortb2Imp.hasOwnProperty('ext')){

                prebidAdUnit.ortb2Imp.ext.tid = tid;
            }

            // Override video properties.
            if(prebidAdUnit.hasOwnProperty('mediaTypes') && prebidAdUnit.mediaTypes.hasOwnProperty('video')){

                if(window.adsNinjaHeaderBiddingManager.isAppleOsFamily()){

                    prebidAdUnit.mediaTypes.video.mimes = ['video/mp4', 'application/javascript'];
                }

                if('videoPlayer' === ad.getRenderer()){

                    var playerSize                           = (adSize) ? adSize : [640, 480];
                    prebidAdUnit.mediaTypes.video.sizes      = [playerSize];
                    prebidAdUnit.mediaTypes.video.playerSize = playerSize;

                    prebidAdUnit.sizes.push(playerSize);

                    if('videoCompanion' === ad.getBidType() && window.adsNinjaHeaderBiddingManager.isAdFloating(prebidAdUnit.code)){

                        prebidAdUnit.mediaTypes.video.placement = 5;
                    }
                }
                else if('videoPlayer' !== ad.getRenderer()){

                    if(window.adsNinjaHeaderBiddingManager.isAdFloating(prebidAdUnit.code)){

                        prebidAdUnit.mediaTypes.video.placement = 5;
                    }

                    var playerSize = (prebidAdUnit.mediaTypes.video.playerSize) ? prebidAdUnit.mediaTypes.video.playerSize : [304, 171];
                    prebidAdUnit.mediaTypes.video.renderer = this.__createRenderer(playerSize);
                }
            }

            if(prebidAdUnit.bids && prebidAdUnit.bids.length > 0){

                // Add bidder specific overrides.
                for(var z in prebidAdUnit.bids){

                    var bid = prebidAdUnit.bids[z];

                    if('ix' === bid.bidder){

                        bid.params.size = (adSize) ? adSize : bid.params.size;
                    }

                    if('spotx' === bid.bidder){
        
                        bid.params,outstream_options      = bid.params.outstream_options || {};
                        bid.params.outstream_options.slot = prebidAdUnit.code;
                    }

                    if('oneVideo' === bid.bidder && bidInfo[i].mediaType !== 'videoInstream'){

                        bid.params.site          = bid.params.site || {};
                        bid.params.site.page     = window.location.href;
                        bid.params.site.referrer = document.referrer;
                    }
                }
                
                auction.addPrebidAdUnit(prebidAdUnit);
                // window.adsNinjaHeaderBiddingManager.prebidAdUnits.push(prebidAdUnit); // TODO: Look to remove this.
            }            
        }
    }

    return auction;
};

/**
 * Create a renderer for video ads.
 * 
 * @returns object
 */
ANBiddingLibraryPrebid.prototype.__createRenderer = function(playerArraySize){

    return {
        url: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
        render: function(bid){

            bid.status      = 'rendered';
            bid.valnetUsed  = true;
            var adElementId = bid['adUnitCodeGAMRequest'] || bid['adUnitCode'];
            var adElement   = document.getElementById(adElementId);
            var ad          = window.adsNinjaHeaderBiddingManager.__adsData[adElementId];

            // Apply styles for sticky footer video.
            if(ad && 'sticky footer' === ad.zoneName && ad.isFloatingModeAlways()){

                adElement.classList.add('sticky-footer-video');

                playerArraySize = [176, 99];
            }

            window.adsNinja.render({
                headerBiddingLibrary: 'prebid',
                type: 'video',
                video: {
                    adElementId,
                    vastUrl: bid['vastUrl'] || null,
                    vastXml: bid['vastXml'] || null,
                    extraInfo: {
                        adserverTargeting: bid['adserverTargeting'] || null,
                        adUnitId: bid['adUnitId'] || null,
                        auctionId: bid['auctionId'] || null,
                        bidder: bid['bidder'] || null,
                        creativeId: bid['creativeId'] || null,
                        floorData: bid['floorData'] || null,
                        height: bid['height'] || null,
                        params: bid['params'] || null,
                        requestId: bid['requestId'] || null,
                        timeToRespond: bid['timeToRespond'] || null,
                        transactionId: bid['transactionId'] || null,
                        ttl: bid['ttl'] || null,
                        valnetSentNumberOfTimes: bid['valnetSentNumberOfTimes'] || null,
                        vastImpUrl: bid['vastImpUrl'] || null,
                        width: bid['width'] || null,
                    },
                    width: playerArraySize[0],
                    height: playerArraySize[1],
                },
            });
        },
    };
};

/**
 * Initialize the library.
 */
ANBiddingLibraryPrebid.prototype.__init = function(){

    if(window.adsNinjaHeaderBiddingManager.__isPrebidDisabled){

        return;
    }

    window.pbjs             = window.pbjs || {};
    window.pbjs.que         = window.pbjs.que || [];
    var prebidTimeout       = window.adsNinjaHeaderBiddingManager.__prebidTimeout;
    var prebidServerTimeout = prebidTimeout - 300;

    window.pbjs.que.push(function(){ // Enqueue the command to prebid to execute when it's ready

        window.pbjs.enableAnalytics([
            {provider: 'adagio'}, //Enable Adagio Analytics adapter
            {
                provider: 'atsAnalytics',
                options: {
                    pid: '13704'
                }
            }
        ]);

        var priceBuckets = [
            { max:  5, increment : 0.01, },
            { max: 10, increment : 0.05, },
            { max: 20, increment : 0.10, },
            { max: 50, increment : 0.25, },
        ];

        var customConfigObjectForVideo = {
            buckets: [
                { max: 10, increment: 0.05, },
                { max: 20, increment: 0.25, },
                { max: 50, increment: 0.50, },
            ],
        };

        //Set up SNM Price buckets if SNM domain
        var validDomainsSNM = [
            'thesportster.com'
        ];

        for(var a in validDomainsSNM){

            if(-1 !== window.location.hostname.indexOf(validDomainsSNM[a])){

                priceBuckets = [
                    { max: 50.99, increment: 0.01}
                ];

                break;
            }
        }

        // Custom bucket as defined
        var customConfigObject = {
            buckets: priceBuckets,
        };

        var ortbMobile = window.adsNinjaHeaderBiddingManager.isMobile() ? 1 : 0;

        // Prebid configuration.
        var prebidConfig = {
            bidderTimeout: window.adsNinjaHeaderBiddingManager.__prebidTimeout,                		// Timeout 2 sec to match A9
            //sendBidsControl: { bidLimit: 1 },				// Send top 1 bid received
            disableAjaxTimeout: true,
            targetingControls: {
                alwaysIncludeDeals: true				// Even if a bid is not highest, if there's a deal, will send it.
            },
            mediaTypePriceGranularity: {
                banner: customConfigObject,
                'video-instream': customConfigObjectForVideo,
                'video-outstream': customConfigObject,
            },		// Set price granularity object
            pageUrl: document.location.href,
            // sizeConfig: [{                       		// Supported sizes
            //     'mediaQuery': '(min-width: 0px)',
            //     'sizesSupported': [[320,50], [300,250], [300,600], [336,280], [728,90], [970,250], [640, 400]],
            //     'labels': ['any']
            // }],
            userSync: {                         		// Enable user sync in iframe (vs image)
                filterSettings:{
                    iframe:{
                        bidders: '*',                   // Enables all iframe based userSyncs.
                        filter: 'include',
                    },
                    image: {
                        bidders: '*',                   // Enables all image based userSyncs.
                        filter: 'include',
                    },
                },
                iframeEnabled: true,
                userIds: [{
                    name: 'criteo',
                }, {
                    name: "id5Id",
                    params: {
                        partner: 518,
                    },
                    storage: {
                        type: "html5",            // Param "html5" is the required storage type.
                        name: "id5id",            // Param "id5id" is the required storage name.
                        expires: 90,              // Storage lasts for 90 days.
                        refreshInSeconds: 8*3600, // Refresh ID every 8 hours to ensure it's fresh.
                    },

                },{
                    name: "identityLink",
                    params: {
                        pid: '13704',             // Set your real ATS Placement ID here
                        // notUse3P: true/false    // If you do not want to use 3P endpoint to retrieve the envelope. If you do not set this property to true, 3P endpoint will be fired. By default this property is undefined and 3P request will be fired.
                    },
                    storage: {
                        type: "cookie",
                        name: "idl_env",       // "idl_env" is the required storage name
                        expires: 15,            // Identity envelope can last for 15 days
                        refreshInSeconds: 1800,
                    }
                },{
                    name: 'hadronId',
                    storage: {
                        name: 'hadronId',
                        type: 'html5'
                    },
                    params: {
                        partnerId: 269
                    }
                }, {
                    name: "amxId",
                    storage: {
                        type: "html5",
                        name: "amxId",
                        expires: 1
                    }
                }, {
                    name: "sharedId",
                    params: {
                        pixelUrl: "/cvx/client/sync/fpc" //the path your web server will forward to Epsilon
                    },
                    storage: {
                        type: "cookie",
                        name: "_pubcid",
                        expires: 365
                    }
                }, {
                    name: "lotamePanoramaId",
                    params: {
                        clientId: "17231"
                    }
                }, {
                    name: "pairId",
                    params: {
                        liveramp: {
                            storageKey: '_lr_pairId'
                        }
                    }
                }, {
                    name: "unifiedId",
                    params: {
                        partner: "a9ik5j7",
                    },
                    storage: {
                        type: "cookie",
                        name: "pbjs-unifiedid",       // create a cookie with this name
                        expires: 60,                   // cookie can last for 60 days
                    },
                }],
                syncDelay: 5000,
                syncEnabled: true,
            },
            // debug: true,
            // debugging: {
            //     enabled: true,
            //     bids: [{
            //         cpm: 9.9
            //     }]
            // },
            usePrebidCache: true,
            cache: {
                url: 'https://prebid.adnxs.com/pbc/v1/cache', // TODO: Need different set of line items because of the creatives.
                // url: 'https://pbs.adsninja.ca/cache',
                ignoreBidderCacheKey: true, // TODO: Do we need this?
            },
            deviceAccess: true,
            yahoossp: { mode: 'all' },
            improvedigital: {
                usePrebidSizes: true,
            },
            paapi: {
                enabled: true,
                bidders: ['openx', 'pubmatic', 'criteo', 'ix'],
                defaultForSlots: 1
            },
            enableTIDs: true                
        }

        // Test prebid local cache
        const excludedDomains = ['military.com'];
        if (!excludedDomains.some(domain => window.location.hostname.includes(domain))) {
            prebidConfig.cache = { useLocal: true };
        }

        if(!prebidConfig.hasOwnProperty("ortb2")){
            
            prebidConfig.ortb2 = {
                site: {
                    mobile: ortbMobile
                }
            };
        }

        if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheThings'){

            prebidConfig.sendBidsControl = { bidLimit : 1 }; // Send only top bid received.
        }
        else{

            prebidConfig.enableSendAllBids = true; // Send all bids received.

        }

        // Set UID2 if email is available
        if(typeof window.websiteUserEmail !== 'undefined' && window.websiteUserEmail !== ''){
            
            prebidConfig.userSync.userIds.push({
                name: "uid2",
                params : {
                    serverPublicKey: "UID2-X-P-MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE3ezCBA1qMBPSgum+q7S1mt7q4D+XS0xuRNr5rwPdC1RmG1aYeknuRUayo8z3J6eF2xam7YuoNq9N02q9XiBvhg==",
                    subscriptionId: "SKZwkDyxLh",
                    email: window.websiteUserEmail
                }
            });
        } 

        if (typeof window.OzoneHashedEmail !== 'undefined' && window.OzoneHashedEmail !== '') {
            prebidConfig.userSync.userIds.push({
                name: "pubProvidedId",
                bidders: ['ozone'],
                params: {
                    eids: [{  
                        source: "ozoneproject.com",  
                        uids: [{  
                            id: window.OzoneHashedEmail, 
                            atype: 3,  
                            ext: {  
                                stype: "ppuid"  
                            }  
                        }]  
                    }] 
                }
            })
        }

        var floors = {};
        
        if(window.adsNinja 
            && window.adsNinja.floorHelper
            && typeof window.adsNinja.floorHelper.getBidstreamFloorsForPrebid === 'function'
        ){

            floors = window.adsNinja.floorHelper.getBidstreamFloorsForPrebid();

            if(floors 
                && typeof floors === 'object' 
                && Object.keys(floors).length > 0
                && typeof window.adsNinja.floorHelper.getCustomKeySchemaForPrebid === 'function'
                && typeof window.adsNinja.floorHelper.constructAdditionalSchemaFieldLookupsAttributeForPrebid === 'function'
            ){

                prebidConfig.floors = {
                    data: {
                        currency: 'USD',
                        skipRate: 0,
                        schema: window.adsNinja.floorHelper.getCustomKeySchemaForPrebid(),
                        values: floors,
                    },
                    additionalSchemaFields : window.adsNinja.floorHelper.constructAdditionalSchemaFieldLookupsAttributeForPrebid(),
                };
            }
        }

        prebidConfig.realTimeData = {
            auctionDelay: 100,
            dataProviders: [{
                name: "hadron",
                waitForIt: true,
                params: {
                    segmentCache: false,
                    partnerId: 269
                }
            },
            {
                name: 'airgrid',
                waitForIt: true,
                params: {
                    apiKey: 'b151b0a8-b368-414e-b29c-9fa42b1f9b00',
                    accountId: '0Iu7Vb',
                    publisherId: 'v7hh13',
                    bidders: ['appnexus']
                }
            }]
        };

        if(!window.adsNinjaHeaderBiddingManager.__consentContext && window.adsNinjaHeaderBiddingManager.__consentNeeded){

            // TODO: Remove.
            // For deployment compatability.
            prebidConfig.consentManagement = {
                gdpr: {
                    cmpApi: 'iab',
                    timeout: 100,
                    defaultGdprScope: true
                },
                usp: {
                    cmpApi: 'iab',
                    timeout: 100
                },
            };
        }
        else if('gdpr' === window.adsNinjaHeaderBiddingManager.__consentContext){

            prebidConfig.consentManagement = {
                gdpr: {
                    cmpApi: 'iab',
                    timeout: 100,
                    defaultGdprScope: true,
                },
            };
        }
        else if('gpp' === window.adsNinjaHeaderBiddingManager.__consentContext){

            prebidConfig.consentManagement = {
                usp: {
                    cmpApi: 'iab',
                    timeout: 100,
                },
                gpp:{
                    cmpApi: 'iab',
                    timeout: 100,
                },
            };
        }

        if(window.adsNinjaHeaderBiddingManager.__prebidServerAliasData && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData.hasOwnProperty('aliases') && Object.keys(window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['aliases']).length > 0 && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData.hasOwnProperty('bidders') && window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['bidders'].length > 0){

            prebidConfig.s2sConfig = [{
                accountId: '1001',
                enabled: true,
                bidders: window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['bidders'],
                timeout: prebidServerTimeout,
                adapter: 'prebidServer',
                endpoint: {
                    // Defines the auction endpoint or the cookie_sync endpoint for the Prebid Server cluster for non-consent requests or users who grant consent.
                    p1Consent: 'https://pbs.adsninja.ca/openrtb2/auction',
                    // Defines the auction endpoint or the cookie_sync endpoint for the Prebid Server cluster for users who do not grant consent.
                    // (This is useful for a server configured to not accept any cookies to ensure compliance regulations.)
                    noP1Consent: 'https://pbs.adsninja.ca/openrtb2/auction'
                },
                syncEndpoint: {
                    p1Consent: 'https://pbs.adsninja.ca/cookie_sync',
                    noP1Consent: 'https://pbs.adsninja.ca/cookie_sync'
                },
                extPrebid: {
                    cache: {
                        vastxml: { returnCreative: false }
                    },
                    targeting: {
                        pricegranularity: {"ranges": priceBuckets}
                    },
                    aliases: window.adsNinjaHeaderBiddingManager.__prebidServerAliasData['aliases'],
                }
            }];
        }

        prebidConfig.gvlMapping = {
            
            omnidex: 1463
         
        };

        window.pbjs.setConfig(prebidConfig);

        window.pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },
        };

        // Criteo settings
        if(typeof window.CriteoHashedEmail !== 'undefined' && window.CriteoHashedEmail !== ''){

            window.pbjs.setBidderConfig({
                bidders: ['criteo'],
                config: {
                    ortb2: {
                        user: {
                            ext: {
                                data: {
                                    eids: [{
                                        source: window.location.hostname,
                                        uids: [{
                                            id: window.CriteoHashedEmail,
                                            atype: 3,
                                            ext: {
                                                stype: "hemsha256"
                                            }
                                        }]
                                    }]
                                }
                            }
                        }
                    }
                }
            });
        }

        window.adsNinjaHeaderBiddingManager.registerEventHandlerBidWonPrebid();
        window.adsNinjaHeaderBiddingManager.registerEventHandlerBidResponsePrebid();
    });

    var brandName             = window.adsNinjaHeaderBiddingManager.getBrandName();
    var liveIntentBrandConfig = LIVEINTENT_BRAND_MAP[brandName];

    initLiveIntent(liveIntentBrandConfig);
};

window.ANBiddingLibraryPrebid = ANBiddingLibraryPrebid;
